import axios from "axios";
import {Base_URL} from "../url"

// const API_GET_URL = "http://192.168.29.242:5090/api/EventDetails/EventGetData";

export const fetchEventData = async () => {
  try {
    const response = await axios.get(`${Base_URL}/EventDetails/EventGetData`);
    console.log("API Response:", response.data); // Debugging
    return response.data; // If data is directly inside response, return response.data
  } catch (error) {
    console.error("API Fetch Error:", error);
    throw error.response?.data || "Failed to fetch event data";
  }
};
